import React from 'react';
import { FormField, FormInput } from 'semantic-ui-react';

import './FormInputWithInlineError.module.css';

const FormInputWithInlineError = (props) => (
  <FormInput className='inline-errors' {...props} />
);

export const FormFieldWithInlineError = (props) => (
  <FormField className='inline-errors' {...props} />
);

export default FormInputWithInlineError;
